/**
 * 初始化声明
 * @description
 * 对应 GetReady，标识需要预先执行的函数;
 * 声明 GetReady 的函数如果检测不到相应的函数则会重新执行 Initialize 函数
 */
export var Initialize = function Initialize(_target, _property, descriptor) {
  var noConfilt = descriptor.value;

  if (typeof noConfilt === 'function') {
    descriptor.value = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var value = noConfilt.bind.apply(noConfilt, [this].concat(args));
      this.$$initialMethod = value;
    };
  }

  return descriptor;
};